export const initPageComponents = () => {
  setTimeout(() => document.body.classList.remove('loading'), 400);
};
